import { createModule } from '@soltalabs/stateless'
import { SiteService } from './service'
import { schema, normalize } from 'normalizr'
import { prop } from '@soltalabs/ramda-extra'

const INITIAL_STATE = Object.freeze({
  entities: {},
  order: [],
})

const siteEntity = new schema.Entity('sites')

const fetchSites = (module) => async () => {
  const response = await SiteService.list()
  const normalized = normalize(response, [siteEntity])
  const sites = prop('sites')(normalized.entities)
  const order = normalized.result

  module.setState({
    entities: sites,
    order,
  })
}

const SiteModule = createModule({
  name: 'site',
  initialState: INITIAL_STATE,
  decorators: {
    fetchSites,
  },
})

export { SiteModule }
